import React from 'react';
import { FlexGrid, Paper, Styler, TypographyBody } from '@honeycomb/ui-core';
import { getIcon } from './USPs';

// TODO: possibly source data from Umbraco
const uspItems = [
    {
        id: 1,
        title: '24/7 CUSTOMER SUPPORT',
        icon: 'twenty-four-seven',
    },
    {
        id: 2,
        title: 'EASY PAYMENT PLANS',
        icon: 'easy-payment',
    },
    {
        id: 3,
        title: 'FLEXIBLE BOOKINGS',
        icon: 'flexible',
    },
];

export function InterstitialUSPs(): React.JSX.Element | null {
    return (
        <FlexGrid container={true} flexDirection={{ xs: 'column', m: 'row' }} spacing={5}>
            {uspItems.map((uspItem, index) => {
                const { id, icon, title } = uspItem;
                return (
                    <FlexGrid xs={12} m={4} key={id}>
                        <Paper
                            display="flex"
                            alignItems="center"
                            gap={3}
                            px={4}
                            py={2}
                            h="100%"
                            data-id="interstitial-usp"
                        >
                            <Styler data-id={`interstitial-usp-icon-${index}`}>{getIcon(icon?.toLowerCase())}</Styler>
                            <TypographyBody
                                component="h4"
                                color="text.body"
                                weight="semiBold"
                                size="xs"
                                mb={0.5}
                                data-id={`interstitial-usp-title-${index}`}
                            >
                                {title}
                            </TypographyBody>
                        </Paper>
                    </FlexGrid>
                );
            })}
        </FlexGrid>
    );
}
